/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-24 12:19:17
 * @LastEditors: caiqin.xie
 * @message: 搜索结果页-搜索组件
 */
import React, { useState } from "react";
import { Input } from "@arco-design/web-react";
import { IconSearch } from "@arco-design/web-react/icon";
import { quickSearchList } from "@/common/const";
import styles from "../../index.module.scss";
import classNames from "classnames";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  keyword: string; // 搜索关键字
  labelName: string; // 搜索标签
  searchFun: (keyword: string, labelName: string) => void; // 搜索
  setkeyword: (keyword: string) => void; // 搜索关键字赋值
}
const Search = (props:IProps) => {
  const {ctry, words, keyword, searchFun, setkeyword, labelName} = props

  // 关键字搜索
  const searchResultHandler = () => {
    searchFun(keyword, '')
  }

  // 点击标签搜索
  const handleClick = (item: Record<string, string>) => {
    searchFun(keyword, words[item.name])
  }

  return (
    <div className={styles['result-search-wrap']}>
      <div className={styles["search-input"]}>
        <Input
          prefix={<IconSearch />}
          size="large"
          placeholder={words.support_home_banner_search_placeholder}
          value={keyword.trim()}
          onChange={(value: string) => setkeyword(value)}
          onPressEnter={searchResultHandler} />
      </div>
      <div className={styles["quick-search"]}>
        {quickSearchList.map(item => (
          <span
            key={item.id}
            className={classNames(styles["quick-search-item"], {
              [styles["active"]]: words[item.name] == labelName,
            })}
            onClick={() => handleClick(item)}>{words[item.name]}</span>
        ))}
      </div>
    </div>
  )
}
export default Search